export default {
  SET_PROPERTY_OWNERS(state, items) {
    state.PropertyOwners = items;
  },
  REMOVE_ITEM(state, itemId) {
    const ItemIndex = state.PropertyOwners.findIndex((p) => p.Id == itemId)
    state.PropertyOwners.splice(ItemIndex, 1)
  },
  GET_ITEM_BY_ID(state, PropertyOwner) {
    state.PropertyOwner = PropertyOwner;
  },
  UPDATE_PROPERTY_OWNER(state, updatedOwner) {
    const index = state.PropertyOwners.findIndex((p) => p.Id === updatedOwner.Id);
    if (index !== -1) {
      state.PropertyOwners.splice(index, 1, updatedOwner);
    }
  },
  TOGGLE_OWNER_ACTIVE_STATUS(state, ownerId) {
    const index = state.PropertyOwners.findIndex(i => i.Id === ownerId);
    if (index !== -1) {
      const currentStatus = state.PropertyOwners[index].IsActive;
      state.PropertyOwners[index].IsActive = !currentStatus;
    }
  },
    ADD_ITEM(state, item) {
    
    state.PropertyOwners.unshift(item)
  },
}